



var PhxCheckout = (function (PhxCheckout) {

    PhxCheckout.messenger = function messenger() {

        function _parseOrigin(origin) {
            origin = origin.split(":")[1];
            origin = origin.replace(/^\/\//, '');
            origin = origin.replace(/^[\w]+\./, '');
            return origin; 
        }

        function _isSameOrigin(event) {
            var localWindow = PhxCheckout.util.getWindow();
            var srcOrigin = event.origin || event.originalEvent.origin;
            //IE 11 weird hack for origin
            var windowOrigin = (!localWindow.location.origin) ? localWindow.location.protocol + "//" + localWindow.location.hostname  + (localWindow.location.port ? ':' + localWindow.location.port: '') : localWindow.location.origin;
            var srcBaseOrigin = _parseOrigin(srcOrigin);
            var ourBaseOrigin = _parseOrigin(windowOrigin);
            if (srcBaseOrigin === ourBaseOrigin) {
                return true;
            }
            if (console) {
                console.log('sameOriginCheck failed: ', srcBaseOrigin, ourBaseOrigin)
            }
            return false;
        }

        // based on http://stackoverflow.com/a/12380392
        function _getFunction(functionName) {
            var scope = PhxCheckout;
            var scopeSplit = functionName.split('.');
            for (i = 0; i < scopeSplit.length - 1; i++) {
                scope = scope[scopeSplit[i]];
                if (scope == undefined) {
                    return;
                }
            }
            return scope[scopeSplit[scopeSplit.length - 1]];
        }

        function _messageHandler(event) {
            var response, error;
            if (_isSameOrigin(event)) {
                try {
                    response = _getFunction(event.data.name)(event.data.payload);
                } catch (e) {
                    error = e.message;
                }
                _postMessageToParent({
                    id: event.data.id,
                    response: response,
                    error: error,
                    action: 'FRAMEMESSENGEREVENT'
                });
            }
        }

        function _postMessageToParent(data) {
            var localWindow = PhxCheckout.util.getWindow();
            localWindow.parent.postMessage(data, "*");
        }

        return {
            messageHandler: _messageHandler,
            postMessageToParent: _postMessageToParent
        }
    }();

    return PhxCheckout;

}(PhxCheckout || {}));

if(window.addEventListener) {
    window.addEventListener("message", PhxCheckout.messenger.messageHandler, false);
} else if(window.attachEvent) {
    window.attachEvent("message", PhxCheckout.messenger.messageHandler);
}